export default "__VITE_ASSET__D$EoWuji__"